export default "__VITE_ASSET__b01ad89d__"